export const selectEmail = (state) => state.userAuth.email;
export const selectSession = (state) => state.userAuth.session;
export const selectError = (state) => state.userAuth.error;
export const selectTransactionType = (state) => state.userAuth.transactionType;
export const selectSignInloading = (state) => state.userAuth.signInloading;
export const selectPassword = (state) => state.userAuth.password;
export const selectSuccessMessage = (state) => state.userAuth.successMessage;
